import { ForwardedRef, forwardRef } from "react";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import { ButtonProps as MUIButtonProps, IconButton } from "@mui/material";

const InfoButton = forwardRef(function ButtonBase<C extends React.ElementType>(
  { sx, ...props }: MUIButtonProps<C, { component?: C }>, //https://mui.com/material-ui/guides/composition/#with-typescript
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <IconButton ref={ref} sx={sx} {...props}>
      <InfoIcon />
    </IconButton>
  );
});

export default InfoButton;
